export const setUsers = ({ users }) => state => {
  return {
    ...state,
    users,
    loadingUsers: false,
  };
};
